export default __webpack_public_path__ + "static/media/gallery_00.6a431f07.jpg";